import React from "react";
import {
  ProSidebar,
  Menu,
  MenuItem,
  SubMenu,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
} from "react-pro-sidebar";
import sidebarBg from "../../images/bgSide.jpg";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ThreeCircles } from "react-loader-spinner";
import {
  FaUsers,
  FaChartArea,
  FaServer,
  FaUserCheck,
  FaWhmcs,
  FaUserShield,
  FaInfo,
  FaLock,
  FaPowerOff,
  FaBookReader,
  FaCity,
  FaMoneyBillAlt,
  FaFileSignature,
  FaUniversity,
  FaCalculator,
  FaList,
  FaCheck,
  FaHandshake,
  FaMoneyBill,
  FaGift,
  FaPersonBooth,
  FaExchangeAlt,
  FaGitter,
  FaGifts,
  FaAlignCenter,
  FaSlideshare,
  FaProductHunt,
  FaImages,
  FaBell,
  FaThList,
} from "react-icons/fa";
import "../../styles/App.scss";
import sysJwt from "../../utils/sysJwt";

const Aside = ({ username, isLoading, handleLogout }) => {
  const [toggled, setToggled] = useState(false);

  const handleClick = (event) => {
    setToggled(!toggled);
  };

  return (
    <div className={`app ${1 === 1 ? "rtl" : ""} ${1 === 1 ? "toggled" : ""}`}>
      <ProSidebar
        image={sidebarBg}
        rtl={true}
        collapsed={toggled}
        toggled={true}
        breakPoint="md"
        width={230}
      >
        <SidebarHeader>
          <div
            style={{
              padding: "24px",
              textTransform: "uppercase",
              fontWeight: "bold",
              fontSize: 14,
              letterSpacing: "1px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {!isLoading ? (
              <i className="fa fa-bars" onClick={handleClick} />
            ) : (
              ""
            )}
            {isLoading ? (
              <ThreeCircles color="white" height="25" width="25" />
            ) : (
              <a href="/dashboard/home">نظام احتساب النقاط</a>
            )}
          </div>
        </SidebarHeader>

        <SidebarContent>
          <Menu iconShape="circle">
            {sysJwt.isAuthorized(["CABD"]) && (
              <SubMenu icon={<FaWhmcs />} title="النظام">
                {sysJwt.isAuthorized(["CABD", "CABE"]) && (
                  <MenuItem icon={<FaUsers />}>
                    <Link to="/dashboard/usermanagement">المستخدمين</Link>
                  </MenuItem>
                )}
                {sysJwt.isAuthorized(["CABD", "CAC5"]) && (
                  <MenuItem icon={<FaUserShield />}>
                    <Link to="/dashboard/rolemanagement">الصلاحيات</Link>
                  </MenuItem>
                )}
                {sysJwt.isAuthorized(["CABD", "CAD5"]) && (
                  <MenuItem icon={<FaServer />}>
                    <Link to="/dashboard/systemparameters">أعدادات النظام</Link>
                  </MenuItem>
                )}
              </SubMenu>
            )}
            {sysJwt.isAuthorized(["CAF2"]) && (
              <SubMenu icon={<FaBookReader />} title="التعاريف">
                {sysJwt.isAuthorized(["CAF2", "CAF3"]) && (
                  <MenuItem icon={<FaGitter />}>
                    <Link to="/dashboard/agentgiftscategories">
                      انواع جوائز الوكلاء
                    </Link>
                  </MenuItem>
                )}
                {sysJwt.isAuthorized(["CAF2", "CAF7"]) && (
                  <MenuItem icon={<FaGifts />}>
                    <Link to="/dashboard/agentgifts">جوائز الوكلاء</Link>
                  </MenuItem>
                )}
                {sysJwt.isAuthorized(["CAF2", "CAFB"]) && (
                  <MenuItem icon={<FaAlignCenter />}>
                    <Link to="/dashboard/pipefittergiftscategories">
                      انواع جوائز السباكين
                    </Link>
                  </MenuItem>
                )}
                {sysJwt.isAuthorized(["CAF2", "CAFF"]) && (
                  <MenuItem icon={<FaGift />}>
                    <Link to="/dashboard/pipefittergifts">جوائز السباكين</Link>
                  </MenuItem>
                )}
                {sysJwt.isAuthorized(["CAF2", "CB03"]) && (
                  <MenuItem icon={<FaSlideshare />}>
                    <Link to="/dashboard/agencies">الوكالات التجارية</Link>
                  </MenuItem>
                )}
                {sysJwt.isAuthorized(["CAF2", "CB07"]) && (
                  <MenuItem icon={<FaProductHunt />}>
                    <Link to="/dashboard/agenciesproducts">منتجات الوكلات</Link>
                  </MenuItem>
                )}
                {sysJwt.isAuthorized(["CAF2", "CB0B"]) && (
                  <MenuItem icon={<FaImages />}>
                    <Link to="/dashboard/slider">شريط الصور</Link>
                  </MenuItem>
                )}
                {sysJwt.isAuthorized(["CAF2", "CB0E"]) && (
                  <MenuItem icon={<FaBell />}>
                    <Link to="/dashboard/notifs">الاشعارات</Link>
                  </MenuItem>
                )}
              </SubMenu>
            )}
            {sysJwt.isAuthorized(["CB10"]) && (
              <SubMenu icon={<FaHandshake />} title="الوكلاء">
                {sysJwt.isAuthorized(["CB10", "CB11"]) && (
                  <MenuItem icon={<FaThList />}>
                    <Link to="/dashboard/agents">قائمة الوكلاء</Link>
                  </MenuItem>
                )}
                {sysJwt.isAuthorized(["CB10", "CB14"]) && (
                  <MenuItem icon={<FaMoneyBill />}>
                    <Link to="/dashboard/agentsbills">الفواتير</Link>
                  </MenuItem>
                )}
                {sysJwt.isAuthorized(["CB10", "CB16"]) && (
                  <MenuItem icon={<FaGift />}>
                    <Link to="/dashboard/agentsrequests">طلبات الجوائز</Link>
                  </MenuItem>
                )}
              </SubMenu>
            )}
            {sysJwt.isAuthorized(["CB19"]) && (
              <SubMenu icon={<FaPersonBooth />} title="السباكين">
                {sysJwt.isAuthorized(["CB19", "CB1A"]) && (
                  <MenuItem icon={<FaThList />}>
                    <Link to="/dashboard/pipefitters">قائمة السباكين</Link>
                  </MenuItem>
                )}
                {sysJwt.isAuthorized(["CB19", "CB1B"]) && (
                  <MenuItem icon={<FaExchangeAlt />}>
                    <Link to="/dashboard/pipefitterstransfer">التحويلات</Link>
                  </MenuItem>
                )}
                {sysJwt.isAuthorized(["CB19", "CB1C"]) && (
                  <MenuItem icon={<FaGift />}>
                    <Link to="/dashboard/pipefittersrequests">
                      طلبات الجوائز
                    </Link>
                  </MenuItem>
                )}
              </SubMenu>
            )}
            {sysJwt.isAuthorized(["CB1D"]) && (
              <MenuItem icon={<FaUsers />}>
                مستخدمين التطبيق <Link to="/dashboard/mobileuser" />
              </MenuItem>
            )}
            {sysJwt.isAuthorized(["CAEC"]) && (
              <MenuItem icon={<FaChartArea />}>
                التقارير <Link to="/dashboard/reports" />
              </MenuItem>
            )}
            <MenuItem icon={<FaInfo />}>
              <Link to="/dashboard/applicationinfo">حول النظام</Link>
            </MenuItem>
            <MenuItem icon={<FaLock />}>
              <Link to="/dashboard/changepassword">تغيير كلمة المرور</Link>
            </MenuItem>
            <MenuItem icon={<FaPowerOff />}>
              <a onClick={() => handleLogout()}>تسجيل خروج</a>
            </MenuItem>
          </Menu>
        </SidebarContent>

        <SidebarFooter style={{ textAlign: "center" }}>
          <div
            className="sidebar-btn-wrapper"
            style={{
              padding: "20px 24px",
            }}
          >
            <a className="sidebar-btn" rel="noopener noreferrer">
              <FaUserCheck />
              <span
                style={{
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                }}
              >
                {username}
              </span>
            </a>
          </div>
        </SidebarFooter>
      </ProSidebar>
    </div>
  );
};

export default Aside;
